export default {
  getWatches: (internetUserId) => `/user-event-watches/users/${internetUserId}`,
  updateWatches: (internetUserId) => `/user-event-watches/users/${internetUserId}`,
  watchGroupDelete: (watchGroupIdentifier) => `/case-user-event-watches/groups/${watchGroupIdentifier}`,
  getAvailableWatches: (internetUserId) => `/case-event-types/users/${internetUserId}`,
  getCaseWatches: (controlNumber, internetUserId) => `/case-user-event-watches/cases/${controlNumber}/users/${internetUserId}`,
  updateCaseWatches: (controlNumber, internetUserId) => `/case-user-event-watches/cases/${controlNumber}/users/${internetUserId}`,
};